export enum RateTypes {
  Customer = 'customer',
  Standard = 'standard',
}
